<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="filteredStock"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="12" class="d-flex mb-n3">
                        <h1 class="mr-4">ASSEMBLY STOCK</h1>
                    </v-col>
                </v-row>
            </template>
            <!-- Header filters -->
            <template v-slot:[`header.partNumberCode`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="partNumberFilter"
                    dense
                />
            </template>

            <template v-slot:[`header.project`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="projectFilter"
                    dense
                />
            </template>
            <!-- Project name and reference -->
            <template v-slot:[`item.project`]="{ item }">
                <p>{{ item.projectReference }} - {{ item.projectName }}</p>
            </template>
            <!-- Origin work order -->

            <template v-slot:[`item.originWorkOrders`]="{ item }">
                <div class="d-flex flex-wrap ga-1">
                    <v-chip
                        v-for="(workOrder, index) in item.originWorkOrders"
                        :key="index"
                        small
                        color="primary"
                        variant="outlined"
                        class="ml-1"
                    >
                        {{ workOrder }}
                    </v-chip>
                </div>
            </template>

            <!-- Actions -->
            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="openAssignWorkOrder(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>

        <!-- Assign assembly wo  -->
        <v-dialog v-model="assignWorkOrder" max-width="600px" persistent>
            <AssignAssembly
                v-if="assignWorkOrder"
                :partNumber="selectedItem"
                :assemblyWOs="selectedWorkOrders"
                @discountQuantity="discountQuantity"
                @closeDialog="closeAssignWorkOrder"
            ></AssignAssembly>
        </v-dialog>
    </div>
</template>

<script>
import API from '@/services/api'
import { mapMutations } from 'vuex'
import _ from 'lodash'
import { firestore } from '@/services/firebase'

export default {
    name: 'AssemblyInventory',
    components: {
        AssignAssembly: () =>
            import('@/components/WorkOrders/AssignAssembly.vue'),
    },
    data: () => ({
        listener: undefined,
        loading: true,
        stock: [],
        assemblyWOs: [],
        partNumberFilter: '',
        projectFilter: '',
        headers: [
            {
                text: 'PART NUMBER',
                value: 'partNumberCode',
                align: 'start',
                sortable: false,
            },
            {
                text: 'VERSION',
                value: 'version',
                align: 'start',
                sortable: false,
            },
            {
                text: 'PROJECT',
                value: 'project',
                align: 'start',
                sortable: false,
            },
            {
                text: 'AVAILABLE QUANTITY',
                value: 'stockQuantity',
                align: 'right',
                sortable: true,
                width: 200,
            },
            {
                text: 'ORIGIN WORK ORDER',
                value: 'originWorkOrders',
                align: 'center',
                sortable: false,
            },
            // {
            //     text: 'ACTIONS',
            //     value: 'actions',
            //     align: 'center',
            //     sortable: true,
            // },
        ],
        assignWorkOrder: false,
        selectedItem: {},
        companyId: JSON.parse(localStorage.getItem('company')),
    }),
    computed: {
        filteredStock() {
            let conditions = []

            if (this.partNumberFilter) {
                conditions.push(this.filterPartNumber)
            }

            if (this.projectFilter) {
                conditions.push(this.filterProject)
            }

            if (conditions.length > 0) {
                return this.stock.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }

            return this.stock
        },
    },
    async mounted() {
        try {
            this.loading = true
            this.assemblyWOs = await API.getAssemblyWorkOrders()
            await this.liveProjects()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        if (this.listener) {
            this.listener()
            this.listener = null
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        filterPartNumber(item) {
            return (
                item.partNumberCode &&
                item.partNumberCode
                    .toLowerCase()
                    .includes(this.partNumberFilter.toLowerCase())
            )
        },
        filterProject(item) {
            return (
                (item.projectReference &&
                    item.projectReference
                        .toString()
                        .toLowerCase()
                        .includes(this.projectFilter.toLowerCase())) ||
                (item.projectName &&
                    item.projectName
                        .toLowerCase()
                        .toString()
                        .includes(this.projectFilter.toLowerCase()))
            )
        },
        openAssignWorkOrder(item) {
            this.selectedItem = _.cloneDeep(item)

            // Filter work orders that need this part number
            this.selectedWorkOrders = this.assemblyWOs.filter(wo => {
                // Must be same project
                if (wo.projectId !== this.selectedItem.projectId) {
                    return false
                }

                // Must have partNumbers
                if (!wo.partNumbers) {
                    return false
                }
                // Check if any item needs this part number in assemblyItems
                for (const partNumberData of Object.values(wo.partNumbers)) {
                    if (!partNumberData.assemblyItems) continue

                    const needsThisPart = Object.keys(
                        partNumberData.assemblyItems
                    ).some(key => key === this.selectedItem.partNumberId)

                    if (needsThisPart) {
                        return true
                    }
                }

                return false
            })

            this.assignWorkOrder = true
        },
        closeAssignWorkOrder() {
            this.selectedItem = {}
            this.assignWorkOrder = false
        },
        discountQuantity(partNumberId, newQuantity) {
            const index = this.stock.findIndex(
                p => p.partNumberId == partNumberId
            )
            if (index >= 0) {
                this.stock[index].stockQuantity -= newQuantity
            }
        },
        async liveProjects() {
            this.projects = []

            let query = firestore
                .collection('companies')
                .doc(this.companyId)
                .collection('projects')

            this.listener = query.onSnapshot(async docSnapshot => {
                for (const change of docSnapshot.docChanges()) {
                    const project = Object.assign(change.doc.data(), {
                        id: change.doc.id,
                    })

                    if (
                        project.partNumberStock &&
                        Object.keys(project.partNumberStock).length > 0
                    ) {
                        const existingProject = this.projects.find(
                            p => p.id === project.id
                        )

                        if (change.type === 'added' && !existingProject) {
                            this.projects.splice(0, 0, project)
                        }
                        if (change.type === 'modified') {
                            const index = this.projects.findIndex(
                                p => p.id === project.id
                            )
                            if (index >= 0) {
                                this.projects.splice(index, 1, project)
                            }
                        }
                        if (change.type === 'removed') {
                            const index = this.projects.findIndex(
                                p => p.id === project.id
                            )
                            if (index >= 0) {
                                this.projects.splice(index, 1)
                            }
                        }
                    }
                }
                // Calculate stock.
                this.rebuildStock()
            })
        },
        rebuildStock() {
            // clean current stock
            this.stock = []
            // Format items
            this.projects.forEach(project => {
                this.formatItems(project)
            })
        },
        formatItems(project) {
            const partNumberStock = project.partNumberStock
            let version2Deliveries = []

            if (partNumberStock && Object.entries(partNumberStock).length > 0) {
                for (let [partNumberId, partNumber] of Object.entries(
                    partNumberStock
                )) {
                    //version 1 support
                    if (partNumber.qty && partNumber.originWorkOrders) {
                        if (partNumber.code) {
                            // add if not exist
                            const index = this.stock.findIndex(
                                p => p.partNumberId == partNumberId
                            )
                            if (index >= 0) {
                                // Add to existing total
                                this.stock[index].stockQuantity +=
                                    +partNumber.qty || 0

                                // add origin work order if not exists
                                if (partNumber.originWorkOrders) {
                                    for (const originWorkOrder of partNumber.originWorkOrders) {
                                        // only add if not exist
                                        if (
                                            !this.stock[
                                                index
                                            ].originWorkOrders.includes(
                                                originWorkOrder
                                            )
                                        ) {
                                            this.stock[
                                                index
                                            ].originWorkOrders.push(
                                                originWorkOrder
                                            )
                                        }
                                    }
                                }
                            } else {
                                // Create new entry
                                this.stock.push({
                                    projectId: project.id,
                                    projectReference: project.reference,
                                    projectSapCode: project.sapCode,
                                    projectName: project.name,
                                    partNumberId: partNumberId,
                                    partNumberCode: partNumber.code,
                                    stockQuantity: +partNumber.qty || 0,
                                    originWorkOrders:
                                        partNumber.originWorkOrders || [],
                                    version: 1,
                                })
                            }
                        }
                    }

                    //version 2 support
                    if (partNumber.deliveries) {
                        //unify deliveries
                        let unifiedDeliveries = []
                        for (const delivery of partNumber.deliveries) {
                            unifiedDeliveries.push({
                                code: partNumber.code,
                                ...delivery,
                            })
                        }
                        //get origin work orders
                        const baseWorkOrders = new Set(
                            unifiedDeliveries.map(
                                delivery => delivery.originWorkOrder
                            )
                        )
                        Array.from(baseWorkOrders).forEach(workOrder => {
                            //filtered deliveries
                            const filteredDeliveries = unifiedDeliveries.filter(
                                delivery =>
                                    delivery.originWorkOrder === workOrder
                            )
                            const stockQuantity = filteredDeliveries.reduce(
                                (acc, delivery) => acc + delivery.qty,
                                0
                            )

                            if (stockQuantity > 0) {
                                version2Deliveries.push({
                                    projectId: project.id,
                                    projectReference: project.reference,
                                    projectSapCode: project.sapCode,
                                    projectName: project.name,
                                    partNumberId: partNumberId,
                                    partNumberCode: partNumber.code,
                                    stockQuantity: stockQuantity,
                                    originWorkOrders: [workOrder],
                                    version: 2,
                                })
                            }
                        })
                    }
                }
            }
            this.stock = [...this.stock, ...version2Deliveries]
        },
    },
}
</script>
